$(function() {
    $(document).on('click', '*[data-role="collapse"]', function (e) {
        e.preventDefault();
        var $parent = $(this).parents('.message');
        var $content = $parent.find('.message-body');

        if ($content.hasClass('is-hidden')) {
            $content.removeClass('is-hidden');
        } else {
            $content.addClass('is-hidden');
        }
    });
});